import JobAppsPage from './JobAppsPage';

export default JobAppsPage;
